import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { VehiclesService } from "./vehicles.service";
import { Router } from "@angular/router";
@Component({
  selector: "app-vehicles",
  templateUrl: "./vehicles.component.html",
  styleUrls: ["./vehicles.component.sass"],
})
export class VehiclesComponent implements OnInit {
  showModal = false;
  selectedVehicle: any = null; // Used for edit
  allVehicleList: [];
  
  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private vehiclesService: VehiclesService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getAllVehicle();
  }

  getAllVehicle() {
    this.spinner.show();
    let data = {
      isActive: 1,
    };
    this.vehiclesService.getAllVehicle(data).subscribe((result: any) => {
      if (result.statusCode == 200) {
        // console.log("get all vehicles ", result);
        this.allVehicleList = result.data;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }
  editVehicle(vehicle: any) {
    this.selectedVehicle = vehicle;
    console.log("selected Vehicle", vehicle);
  }

  handleFormSubmit(data: any) {
    console.log("Vehicle submitted:", data);
    this.getAllVehicle();
  }

  viewVehicle(vehicle: any) {
    this.selectedVehicle = vehicle;
    console.log("selected Vehicle", vehicle);
  }

  deleteVehi(data) {
    this.spinner.show();
    this.vehiclesService.deleteVehicle(data._id).subscribe((result: any) => {
      if (result.statusCode == 200) {
        this.spinner.hide();
        this.toastr.success(result.message);
        this.getAllVehicle();
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }
}
